import script from "./transmitView.vue?vue&type=script&setup=true&lang=js"
export * from "./transmitView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__